export enum AuthorizationVerbiageType {
  BankAuthorization = 'BankAuthorization',
  SurchargeAuthorization = 'SurchargeAuthorization',
  GracePeriodSurchargeAuthorization = 'GracePeriodSurchargeAuthorization',
  PaymentLinksBankAuthorization = 'PaymentLinksBankAuthorization',
  PaymentLinksSurchargeAuthorization = 'PaymentLinksSurchargeAuthorization',
  PaymentLinksGracePeriodSurchargeAuthorization = 'PaymentLinksGracePeriodSurchargeAuthorization',
}
